const ColorUse = {
    colorPrimary: "#f1132a",
    colorGray: "#4c4c4c"
};
export default ColorUse;